import { useCallback } from "react";

export const useFormData = (
  receivers: any[],
  contractId: string,
  subject: string | undefined
) => {
  const getFormData = useCallback(
    (data: any) => {
      const { fileList, email } = data;

      const request: any = {
        receiverIds: [],
        contractId,
      };

      email.forEach((item: string) => {
        const val = receivers.find((data: any) => data.i.toString() === item);

        val && request.receiverIds.push(val.id);
      });

      if (fileList && fileList.length > 0) {
        request.fileItemId = data.fileList[0].response;
      }

      request.subject = subject || data.templateId.label;

      return request;
    },
    [contractId, receivers, subject]
  );

  return { getFormData };
};
